import {defineStore} from "pinia";
import {ref} from "vue";
import {mapCustomerReview} from "@/utils/customerReview.js";

export const useCustomerReviewStore = defineStore("customerReview", () => {
  const reviews = ref([]);

  function setReviews(list) {
    reviews.value = (Array.isArray(list) ? list : []).map(mapCustomerReview);
  }

  return {
    reviews,
    setReviews,
  };
});
